<template>
  <div class="form-group form-group--textarea" v-bind:class="getClass()">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label>{{ component.label }}
          <span class="required" v-if="isRequired()">*</span>
        </label>
        <textarea v-if="component.isTextEditor===false" class="form-control"
                  :id="component.key"
                  v-bind:name="component.key"
                  v-bind:disabled="disabledHandler()"
                  v-bind:rows="component.rows"
                  v-bind:placeholder="component.placeholder"
                  v-bind:minLength="component.validate.minLength"
                  v-bind:maxLength="component.validate.maxLength"
                  v-validate="setRules()"
                  v-bind:data-vv-name="component.key"
                  v-model="component.data.currentValue"
                  v-on:focus="focusHandler()"
                  v-on:blur="blurHandler()"
                  v-html="component.data.currentValue"></textarea>
        <quill-editor ref="myTextEditor"
                      v-if="component.isTextEditor===true"
                      name="descricao"
                      :options="editorOption"
                      :id="component.key"
                      v-bind:name="component.key"
                      v-bind:disabled="disabledHandler()"
                      v-bind:rows="component.rows"
                      v-bind:placeholder="component.placeholder"
                      v-bind:minLength="component.validate.minLength"
                      v-bind:maxLength="component.validate.maxLength"
                      v-validate="setRules()"
                      v-bind:data-vv-name="component.key"
                      v-model="component.data.currentValue"
                      v-on:focus="focusHandler()"
                      v-on:blur="blurHandler()"
                     >
        </quill-editor>
        <span class="help-block help-block--bottom" v-if="errors.has(component.key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">
            <g transform="translate(-252 -635)">
              <rect class="cls-1" width="14" height="14" transform="translate(252 635)"/>
              <path class="cls-2" d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z" transform="translate(251 634)"/>
            </g>
          </svg>
          {{ (errors.first(component.key)) }}
        </span>
        <div class='help-block-container'>
          <div class="help-block-container__helper">
            <span class="help-block help-block--bottom" v-if="!errors.has(component.key)">{{ component.description }}</span>
          </div>
          <div>
            <span class="help-block help-block--bottom" v-if="!errors.has(component.key) && component.validate.maxLength">{{ `${component.data.currentValue.length}/${component.validate.maxLength}` }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  mixins: [component],
  props: ['component'],
  components: {
    quillEditor
  },
  inject: ['$validator'],
  name: 'textarea-field',
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'size': ['small', 'normal', 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'font': [] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'image']
          ]
        }
      }
    }
  },
  created () {
    this.setValue()
    if (!this.component.isTextEditor) {
      this.$set(this.component, 'isTextEditor', false)
    }
  }
}
</script>

<style>
  .help-block-container {
    display: flex;
    flex-direction: row;
  }
  .help-block-container__helper{
    flex-grow: 1;
    overflow: hidden;
  }
  .help-block-container__helper span{
    overflow: hidden;
    white-space:nowrap;
    text-overflow:ellipsis
  }
</style>
